import { createContext, useContext } from "react";
import type { Store } from ".";

export const StoreContext = createContext({} as Store);
export const useStore = () => useContext(StoreContext);
